<div class="tabs">
  <div
    *ngFor="let tab of model.tabs"
    class="tab-item"
    [class.active]="model.activeTabIndex === tab.index"
    (click)="onTabClicked(tab.index)"
  >
    {{ tab.i18nLabel | translate }}
  </div>
</div>
